import type { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';
import { AppShell } from './AppShell';
import { SkeletonGrid } from '../ui/Skeleton';

/** Gate a protected surface: skeleton while hydrating, redirect to /auth when anonymous. */
export function RequireAuth({ children }: { children: ReactNode }) {
  const { status } = useAuth();
  const location = useLocation();

  if (status === 'loading') {
    return (
      <AppShell>
        <div className="pt-8">
          <SkeletonGrid count={6} />
        </div>
      </AppShell>
    );
  }
  if (status === 'anonymous') {
    return <Navigate to="/auth" replace state={{ from: location.pathname + location.search }} />;
  }
  return <AppShell>{children}</AppShell>;
}
